'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Validator2 = require('./Validator');

var _Validator3 = _interopRequireDefault(_Validator2);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StringValidator = function (_Validator) {
  _inherits(StringValidator, _Validator);

  function StringValidator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        messageNotString = _ref.messageNotString,
        messageMaxLength = _ref.messageMaxLength,
        messageMinLength = _ref.messageMinLength,
        messagePattern = _ref.messagePattern,
        maxLength = _ref.maxLength,
        minLength = _ref.minLength,
        pattern = _ref.pattern,
        flags = _ref.flags;

    _classCallCheck(this, StringValidator);

    var _this = _possibleConstructorReturn(this, (StringValidator.__proto__ || Object.getPrototypeOf(StringValidator)).call(this));

    _this.messageNotString = messageNotString;
    _this.messageMaxLength = messageMaxLength;
    _this.messageMinLength = messageMinLength;
    _this.messagePattern = messagePattern;
    _this.maxLength = maxLength;
    _this.minLength = minLength;
    _this.pattern = pattern;
    _this.flags = flags;
    return _this;
  }

  _createClass(StringValidator, [{
    key: 'validate',
    value: function validate(value, attribute, model) {
      // Empty values are fine
      if (!_utils2.default.isDefined(value) || _utils2.default.isEmpty(value)) {
        return Promise.resolve();
      }

      if (!_utils2.default.isString(value)) {
        return Promise.reject(this.createMessage(this.messageNotString || StringValidator.MESSAGE_NOT_STRING, {
          attribute: attribute
        }));
      }

      var length = value.length;

      if (this.minLength && _utils2.default.isNumber(this.minLength) && !(length >= this.minLength)) {
        return Promise.reject(this.createMessage(this.messageMinLength || StringValidator.MESSAGE_MIN_LENGTH, {
          attribute: attribute,
          count: this.minLength
        }));
      }

      if (this.maxLength && _utils2.default.isNumber(this.maxLength) && !(length <= this.maxLength)) {
        return Promise.reject(this.createMessage(this.messageMaxLength || StringValidator.MESSAGE_MAX_LENGTH, {
          attribute: attribute,
          count: this.maxLength
        }));
      }

      var pattern = this.pattern;

      if (pattern) {
        if (_utils2.default.isString(pattern)) {
          pattern = new RegExp(pattern, this.flags);
        }

        var match = pattern.exec(value);

        if (!match) {
          return Promise.reject(this.createMessage(this.messagePattern || StringValidator.MESSAGE_PATTERN, {
            attribute: attribute
          }));
        }
      }

      return Promise.resolve();
    }
  }]);

  return StringValidator;
}(_Validator3.default);

StringValidator.MESSAGE_NOT_STRING = '{attribute} - must be a string';
StringValidator.MESSAGE_MIN_LENGTH = '{attribute} - is too short (minimum is {count} characters)';
StringValidator.MESSAGE_MAX_LENGTH = '{attribute} - is too long (maximum is {count} characters)';
StringValidator.MESSAGE_PATTERN = '{attribute} - is invalid';
exports.default = StringValidator;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/validators/StringValidator.js
// module id = 774
// module chunks = 0